// Builds the sandboxed document for an admin-provided simulation and defines the site <-> simulation protocol.
export const SIM_CMDS = ['start', 'stop', 'reset', 'goto', 'showAnswer', 'answer'];
export const SIM_EVENTS = ['loaded', 'ready', 'metrics', 'state', 'result', 'error'];
export const TRUSTED_CDNS = ['https://cdn.jsdelivr.net', 'https://unpkg.com', 'https://cdnjs.cloudflare.com', 'https://esm.sh', 'https://cdn.skypack.dev'];
const ASSET_HOSTS = ['https://res.cloudinary.com', 'https://static.prod-images.emergentagent.com'];

const CSP = [
  "default-src 'none'",
  `script-src 'unsafe-inline' 'unsafe-eval' blob: ${TRUSTED_CDNS.join(' ')}`,
  `style-src 'unsafe-inline' https://fonts.googleapis.com ${TRUSTED_CDNS.join(' ')}`,
  `font-src data: https://fonts.gstatic.com ${TRUSTED_CDNS.join(' ')}`,
  `img-src data: blob: ${ASSET_HOSTS.join(' ')} ${TRUSTED_CDNS.join(' ')}`,
  `media-src data: blob: ${ASSET_HOSTS.join(' ')}`,
  `connect-src data: blob: ${ASSET_HOSTS.join(' ')} ${TRUSTED_CDNS.join(' ')}`,
  'worker-src blob:',
  "form-action 'none'",
  "base-uri 'none'",
].join('; ');

const BRIDGE = `(function(){var H={},P=window.parent,C=${JSON.stringify(SIM_CMDS)};
function s(t,p){try{P.postMessage({__amn:1,type:t,payload:p===undefined?{}:JSON.parse(JSON.stringify(p))},'*')}catch(e){}}
window.AMN={on:function(n,f){if(C.indexOf(n)>-1&&typeof f==='function')H[n]=f},ready:function(i){s('ready',i||{})},
metrics:function(m){s('metrics',m)},state:function(x){s('state',x)},result:function(r){s('result',r)}};
window.addEventListener('message',function(e){if(e.source!==P)return;var d=e.data;if(!d||d.__amn!==1||C.indexOf(d.type)<0||!H[d.type])return;
try{H[d.type](d.payload||{})}catch(err){s('error',{message:String(err&&err.message||err)})}});
window.addEventListener('error',function(e){s('error',{message:String(e.message||'Script error')})});
window.addEventListener('unhandledrejection',function(e){s('error',{message:String(e.reason&&e.reason.message||e.reason||'Promise error')})});
if(document.readyState!=='loading')s('loaded');else document.addEventListener('DOMContentLoaded',function(){s('loaded')});})();`;

const HEAD_INJECT = `<meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${CSP}"><script>${BRIDGE}</script>`;

export const buildSimDoc = (html) => {
  const src = html || '';
  const head = src.match(/<head[^>]*>/i);
  if (head) return src.replace(head[0], `${head[0]}${HEAD_INJECT}`);
  const root = src.match(/<html[^>]*>/i);
  if (root) return src.replace(root[0], `${root[0]}<head>${HEAD_INJECT}</head>`);
  return `<!doctype html><html><head>${HEAD_INJECT}</head><body>${src}</body></html>`;
};

export const validateSimHtml = (html) => {
  const s = (html || '').trim();
  const issues = [];
  if (!s) return ['الكود فارغ'];
  if (!/^<!doctype html>/i.test(s)) issues.push('يُفضّل أن يبدأ الكود بـ <!doctype html>');
  if (!/<\/html>\s*$/i.test(s)) issues.push('يُفضّل أن ينتهي الكود بـ </html>');
  const ext = [...s.matchAll(/(?:src|href)=["'](https?:\/\/[^"']+)/gi)].map(m => m[1])
    .filter(u => ![...TRUSTED_CDNS, ...ASSET_HOSTS, 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].some(h => u.startsWith(h)));
  if (ext.length) issues.push(`روابط خارجية غير مسموحة وستُحجب: ${[...new Set(ext)].slice(0, 3).join('، ')}`);
  return issues;
};

const TONES = ['green', 'red', 'blue', 'amber', 'gray'];
const str = (v, n = 40) => String(v ?? '').slice(0, n);

export const sanitizeMetrics = (m) => (Array.isArray(m) ? m : []).slice(0, 6)
  .filter(x => x && typeof x === 'object')
  .map(x => ({ label: str(x.label), value: str(x.value, 24), tone: TONES.includes(x.tone) ? x.tone : 'gray' }));

export const isWebGLAvailable = () => {
  try {
    const c = document.createElement('canvas');
    return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
  } catch { return false; }
};

export const ASPECTS = { '16:9': '16 / 9', '4:3': '4 / 3', '1:1': '1 / 1', '21:9': '21 / 9' };
